import React from "react";
import { Repeat } from "lucide-react";

const AREA_COLORS = { credit: "#2F6F8F", savings: "#3E6B37", security: "#A9712A" };

/** Three persona-specific If/Then habits — one per advancement area. */
export const AdvanceHabits = ({ habits, name }) => {
  if (!habits?.length) return null;
  const shortName = (name || "").replace(/^The /, "");
  return (
    <section className="mt-12" data-testid="result-advance-habits">
      <p className="eyebrow text-[#607762]">Your personalized habits</p>
      <h2 className="font-serif text-3xl sm:text-4xl text-[#2C302E] mt-2 leading-tight">
        Three {shortName} habits, written as If/Then loops.
      </h2>
      <p className="mt-4 text-[#4d4f4c] leading-relaxed max-w-2xl">
        A cue you already have, a routine that fits how you decide, and the reward that keeps
        it going. Members switch these on in the Habit Loop.
      </p>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        {habits.map((h) => {
          const accent = AREA_COLORS[h.key] || "#2C302E";
          return (
            <div
              key={h.key}
              className="bg-[#FBFAF6] border border-[#E6E3DB] p-5"
              data-testid={`result-habit-${h.key}`}
            >
              <div className="flex items-center gap-2">
                <Repeat className="h-4 w-4" style={{ color: accent }} />
                <p className="eyebrow" style={{ color: accent }}>{h.area}</p>
              </div>
              <p className="mt-3 font-serif text-lg text-[#2C302E] leading-snug">{h.statement}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};
